import {
  Box,
  Image,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from '@chakra-ui/react';
import { POSTER_DEMO_DATA } from '../posterDemoData';
import { POSTER_DEMO_ICONS, POSTER_DEMO_MENU_ICONS } from '../posterDemoAssets';

export const EventGuideMorePopover = () => {
  const { urls, venue } = POSTER_DEMO_DATA;

  const items = [
    {
      label: 'Parking',
      icon: POSTER_DEMO_MENU_ICONS.parking,
      href: urls.parking,
    },
    { label: 'Visit', icon: POSTER_DEMO_MENU_ICONS.visit, href: urls.visit },
    { label: 'Merch', icon: POSTER_DEMO_MENU_ICONS.merch, href: urls.merch },
    { label: 'Access', icon: POSTER_DEMO_MENU_ICONS.access, href: urls.access },
    { label: 'Add-On', icon: POSTER_DEMO_MENU_ICONS.addOn, href: urls.addOn },
    {
      label: 'Phone',
      icon: POSTER_DEMO_MENU_ICONS.phone,
      href: `tel:${venue.phone.replace(/\s/g, '')}`,
    },
    {
      label: 'Email',
      icon: POSTER_DEMO_MENU_ICONS.email,
      href: `mailto:${venue.email}`,
    },
    {
      label: 'Website',
      icon: POSTER_DEMO_MENU_ICONS.website,
      href: urls.website,
    },
  ];

  return (
    <Menu placement="bottom-end" autoSelect={false}>
      <MenuButton
        as={Box}
        flex={1}
        minW={0}
        cursor="pointer"
        transition="transform 0.15s ease"
        _hover={{ transform: 'scale(1.06)' }}
        _active={{ transform: 'scale(0.98)' }}
      >
        <Image src={POSTER_DEMO_ICONS.more} alt="More" w="100%" />
      </MenuButton>
      <MenuList
        w="180px"
        minW="180px"
        py="6px"
        border="none"
        borderRadius="20px"
        overflow="hidden"
        bg="rgba(245, 245, 245, 0.72)"
        backdropFilter="blur(18px)"
        boxShadow="0px 6px 28px rgba(0, 0, 0, 0.16)"
      >
        {items.map(({ label, icon, href }) => {
          const external = href.startsWith('http');
          return (
            <MenuItem
              key={label}
              as="a"
              href={href}
              target={external ? '_blank' : undefined}
              rel={external ? 'noopener noreferrer' : undefined}
              icon={<Image src={icon} alt="" boxSize="16px" />}
              h="32px"
              px="18px"
              fontSize="13px"
              letterSpacing="-0.3px"
              color="#1a1a1a"
              bg="transparent"
              _hover={{ bg: 'blackAlpha.100' }}
              _focus={{ bg: 'blackAlpha.100' }}
            >
              {label}
            </MenuItem>
          );
        })}
      </MenuList>
    </Menu>
  );
};
